import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/base.component';
import { AppStateInterface } from 'src/app/store/appState.interface';
import { catchForbiddenError, catchServerError } from 'src/app/store/user/user.actions';
import { catchForbiddenErrorSelector, catchServerErrorSelector } from 'src/app/store/user/user.selectors';

@Component({
  selector: 'app-confirm-after-delay-modal',
  templateUrl: './confirm-after-delay-modal.component.html'
})
export class ConfirmAfterDelayModalComponent extends BaseComponent implements OnInit {
  @Input() title: string;
  isLoading: boolean;
  @Input() description: string;
  @Input() confirmText: string;
  @Input() cancelText: string;
  @Output() onConfirm = new EventEmitter<boolean>(false);
  @Output() onCancel = new EventEmitter<boolean>(false);
  @Input() timer = 3;
  remainingTime = this.timer;

  catchServerError$: Observable<boolean | null>;
  catchForbiddenError$: Observable<boolean | null>;

  closeModal() {
    this.onCancel.emit(true);
  }

  constructor(
    private store: Store<AppStateInterface>
  ) {
    super(store);

    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));

  }

  ngOnInit(): void {
    this.remainingTime = this.timer;
    const intervalId = setInterval(() => {
      if (this.remainingTime === 0) {
        clearInterval(intervalId);
      }
      else {
        this.remainingTime = this.remainingTime - 1;
      }
    }, 1000);
    this.catchServerError$.subscribe((result) => {
      if(result) {
        this.isLoading = false;
        this.store.dispatch(catchServerError({ serverError : null }));
      }
    })
    this.catchForbiddenError$.subscribe((result) => {
      if(result) {
        this.isLoading = false;
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    })
  }

  confirmButtonText() {
    return this.confirmText + (this.remainingTime > 0 ? ` (${this.remainingTime})` : '');
  }

  confirm() {
    this.isLoading = true;
    this.onConfirm.emit(true);
  }

}
